var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TBody',_vm._l((_vm.rows),function(row){return _c('tr',{key:("loading-row-" + row)},_vm._l((_vm.cols),function(col){return _c('TBodyTD',{key:("loading-col-" + col)},[_c('div',{staticClass:"bg-gray-100 w-full h-8"})])}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }